import { feature } from "topojson-client";
import { geoContains } from "d3-geo";
import landTopo from "world-atlas/land-110m.json";

let landGeo = null;
export function getLand() {
  if (!landGeo) landGeo = feature(landTopo, landTopo.objects.land);
  return landGeo;
}

// Le prime 5 sono le piazze "hub" (quartier generale operativo), le altre le principali piazze mondiali
export const CITIES = [
  { name: "Milano", lat: 45.4642, lon: 9.19 },
  { name: "Monaco", lat: 43.7384, lon: 7.4246 },
  { name: "Londra", lat: 51.5074, lon: -0.1278 },
  { name: "Parigi", lat: 48.8566, lon: 2.3522 },
  { name: "Dubai", lat: 25.2048, lon: 55.2708 },
  { name: "New York", lat: 40.7128, lon: -74.006 },
  { name: "Mosca", lat: 55.7558, lon: 37.6173 },
  { name: "Singapore", lat: 1.3521, lon: 103.8198 },
  { name: "Hong Kong", lat: 22.3193, lon: 114.1694 },
  { name: "Tokyo", lat: 35.6762, lon: 139.6503 },
  { name: "Mumbai", lat: 19.076, lon: 72.8777 },
  { name: "Sydney", lat: -33.8688, lon: 151.2093 },
  { name: "San Paolo", lat: -23.5505, lon: -46.6333 },
];

// Rete di collegamenti: clique completa tra i 5 hub + rotte verso le altre piazze
export const LINKS = [
  [0, 1], [0, 2], [0, 3], [0, 4], [1, 2], [1, 3], [1, 4], [2, 3], [2, 4], [3, 4],
  [5, 2],   // New York ↔ Londra
  [5, 12],  // New York ↔ San Paolo
  [6, 2],   // Mosca ↔ Londra
  [6, 4],   // Mosca ↔ Dubai
  [10, 4],  // Mumbai ↔ Dubai
  [10, 7],  // Mumbai ↔ Singapore
  [7, 4],   // Singapore ↔ Dubai
  [7, 8],   // Singapore ↔ Hong Kong
  [7, 11],  // Singapore ↔ Sydney
  [8, 9],   // Hong Kong ↔ Tokyo
];

const pointsCache = new Map();

// Griglia regolare lon/lat campionata dentro i poligoni terrestri (dot map)
export function getLandPoints(stepDeg = 2.1) {
  const key = String(stepDeg);
  if (pointsCache.has(key)) return pointsCache.get(key);
  const land = getLand();
  const pts = [];
  for (let lat = -58; lat <= 84; lat += stepDeg) {
    const cosLat = Math.max(Math.cos((lat * Math.PI) / 180), 0.18);
    const lonStep = stepDeg / cosLat;
    for (let lon = -180; lon < 180; lon += lonStep) {
      if (geoContains(land, [lon, lat])) pts.push([lon, lat]);
    }
  }
  pointsCache.set(key, pts);
  return pts;
}
